var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-icon',[_c('icon',{attrs:{"icon":"edit"}})],1),_c('v-list-item-content',[_c('span',{staticClass:".text-heading-5 mt-1 grey--text"},[_vm._v("DRAFT")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }